import React, { useState } from "react";
import { useLocation } from "react-router-dom";
import { useEffect } from "react";
import { useRef } from "react";
import axios from "axios";
import {
  Box,
  Grid,
  Button,
  Typography,
  Stepper,
  Step,
  StepLabel,
} from "@mui/material";
import {
  KeyboardArrowLeft as KeyboardArrowLeftIcon,
  NavigateNext as NavigateNextIcon,
  Add as AddIcon,
  Edit as EditIcon,
  Delete as DeleteIcon,
  CancelPresentation as CancelPresentationIcon,
} from "@mui/icons-material";
import { styled } from "@mui/material/styles";
import StepConnector from "@mui/material/StepConnector";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { ToastContainer } from "react-toastify";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogTitle from "@mui/material/DialogTitle";
import DialogContentText from "@mui/material/DialogContentText";
import { useNavigate } from "react-router-dom";
import UserStep1 from "./UserStep1";
import UserStep2 from "./UserStep2";
import AuthHeader from "../../../../Auth";
import checkAndLock from "../../../../GlobalFunction/checkAndLock";
import CrudButtons from "../../../../GlobalFunction/CrudButtons";
import axiosInstance from "../../../../lib/axios";

const steps = ["User Details", "Property "];

const CustomStepConnector = styled(StepConnector)(({ theme }) => ({
  "& .MuiStepConnector-line": {
    borderColor: "#e0e0e0",
    borderTopWidth: 3,
    borderRadius: 1,
    margin: "7px 30px 20px 30px",
  },
}));

const CustomStepIcon = styled("div")(({ theme, ownerState }) => ({
  width: 40,
  height: 40,
  border: "3px solid",
  borderColor: ownerState.active ? "#635bff" : "#e0e0e0",
  borderRadius: "50%",
  backgroundColor: "transparent",
  display: "flex",
  justifyContent: "center",
  alignItems: "center",
  color: ownerState.active ? "#635bff" : "#999",
  fontSize: "1.2rem",
  fontWeight: "bold",
}));

const CustomStepLabel = styled(StepLabel)({
  flexDirection: "column",
  "& .MuiStepLabel-labelContainer": {
    marginTop: "5px",
  },
});

const UserMst = () => {
  const [activeStep, setActiveStep] = useState(0);
  const [UserId, setUserId] = useState(-1);
  const [UserLoginId, setUserLoginId] = useState(
    sessionStorage.getItem("UserId")
  );
  const [UserData, setUserData] = useState([]);
  const [UserTypeNameData, setUserTypeNameData] = useState([]);
  const [AllTextDisabled, setAllTextDisabled] = useState(false);
  const [AllButtonDisabled, setAllButtonDisabled] = useState(false);
  const [openConfirmDialog, setopenConfirmDialog] = useState(false);
  const [Mode, setMode] = useState("");
  const [Index, setIndex] = useState(0);
  const location = useLocation();
  const navigate = useNavigate();

  useEffect(() => {
    const fetchData = async () => {
      fetchUserTypeData();
      if (location.state) {
        let id = location.state.UserId;
        console.log("id", id);
        fetchUserData(id, "R");
        viewMode();
      } else {
        addMode();
        setMode("add");
      }
    };
    fetchData();
  }, []);

  const fetchUserData = async (id, flag) => {
    try {
      const response = await axiosInstance.post(
        `UserMst/RetriveUserMst`,
        {
          UserId: parseInt(id),
          Flag: flag,
        },
      );

      if (response.data.Status === 0) {
        setUserData(response.data.Data);
        setMode("view");
        setUserId(response.data.Data[0].UserId);
        viewMode();
      }
    } catch (err) {
      console.log("err", err);
    }
  };

  const fetchUserTypeData = async () => {
    try {
      let payload = "";
      const response = await axiosInstance.post(
        `UserTypeMst/GetMakeDropDown`,
        payload,

      );
      if (response.data.Status === 0) {
        setUserTypeNameData(response.data.Data);
      }
    } catch (err) {
      console.log("err", err);
    }
  };

  const viewMode = () => {
    setAllTextDisabled(true);
    setAllButtonDisabled(false);
  };

  const addMode = () => {
    setAllTextDisabled(false);
    setAllButtonDisabled(true);
  };

  const handleStepClick = (ind) => {
    if (Mode !== "add") {
      setActiveStep(ind);
    }
  };

  const handlePrevClick = () => {
    if (UserId != -1) {
      fetchUserData(UserId, "P");
    }
  };

  const handleNextClick = () => {
    if (UserId != -1) {
      fetchUserData(UserId, "N");
    }
  };

  const handleEdit = async () => {
    if (UserId != -1) {
      let Flag = await checkAndLock(UserId, "MstUser", "UserId");
      switch (Flag) {
        case 0:
          addMode();
          setMode("view");
          break;
        case 1:
          toast.info("Record  Already Locked", { autoClose: 500 });
          break;
        case 2:
          toast.info("Record Failed To Locked", { autoClose: 500 });
          break;
        default:
          toast.info("Something Went Wrong", { autoClose: 500 });
      }
    }
  };
  const handleAdd = () => {
    addMode();
    setMode("add");
    setActiveStep(0);
  };
  const handleDelete = () => {
    setopenConfirmDialog(true);
  };
  const handleMoveBack = () => {
    navigate(`/userMasterTable`);
  };
  const handleConfirmDelete = async () => {
    try {
      const response = await axiosInstance.post(
        `UserMst/RetriveUserMst`,
        {
          UserId: UserId,
          Flag: "D",
        },

      );
      console.log("res", response);
      if (response.data.Status === 0) {
        toast.success(response.data.Message);
        fetchUserData(UserId, "L");
        setopenConfirmDialog(false);
      } else {
        toast.info(response.data.Message);
      }
    } catch (error) {
      console.error("Error fetching company data:", error);
    }
  };

  const handleCancelDialogButton = () => {
    setopenConfirmDialog(false);
  };

  return (
    <Grid>
      <Box className="form-container">
        <ToastContainer />
        <Dialog
          open={openConfirmDialog}
          onClose={handleCancelDialogButton}
          aria-labelledby="alert-dialog-title"
          aria-describedby="alert-dialog-description"
        >
          <DialogTitle id="alert-dialog-title">
            {"Confirm Deletion"}
          </DialogTitle>
          <DialogContent>
            <DialogContentText id="alert-dialog-description">
              Are you sure you want to delete this record?
            </DialogContentText>
          </DialogContent>
          <DialogActions>
            <Button
              sx={{
                backgroundColor: "#635bff",
                color: "white",
                "&:hover": {
                  backgroundColor: "#1565c0",
                  color: "white",
                },
              }}
              onClick={handleConfirmDelete}
            >
              Yes
            </Button>
            <Button
              sx={{
                backgroundColor: "#635bff",
                color: "white",
                "&:hover": {
                  backgroundColor: "#1565c0",
                  color: "white",
                },
              }}
              onClick={handleCancelDialogButton}
            >
              No
            </Button>
          </DialogActions>
        </Dialog>
        <Grid container spacing={2} className="rasidant_grid">
          {/* Header Section */}
          <Grid item xs={12} className='form_title'
            sx={{
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'space-between',
              marginTop: '20px',
              flexDirection: { xs: 'column', sm: 'row', md: 'row' }
            }}
          >
            <Grid
              sx={{
                display: 'flex',
                justifyContent: { xs: 'center', sm: 'flex-start' },
                marginBottom: { xs: '10px', sm: 0 }
              }}
            >
              <Button
                variant="contained"
                size="small"
                className='three-d-button-previous'
                sx={{ backgroundColor: '#635BFF', marginRight: { xs: '5px', sm: '10px' }, display: { xs: 'none', sm: 'block' } }}
                disabled={AllButtonDisabled}
                onClick={handlePrevClick}
              >
                <KeyboardArrowLeftIcon />
              </Button>

              <Button
                variant="contained"
                size="small"
                sx={{ backgroundColor: '#635BFF', marginRight: { xs: '5px', sm: '10px' }, display: { xs: 'none', sm: 'block' } }}
                className='three-d-button-next'
                disabled={AllButtonDisabled}
                onClick={handleNextClick}
              >
                <NavigateNextIcon />
              </Button>
            </Grid>

            <Typography
              variant="h5"
              sx={{
                margin: 'Auto',
                textAlign: { xs: 'center', sm: 'center' },
                fontSize: { xs: '24px', sm: '18px', md: '24px' }
              }}
            >
              {activeStep == 0 ? " User Master" : "Property Selection"}
            </Typography>

            <Grid sx={{ display: "flex", justifyContent: "end" }}>
              <CrudButtons
                moduleName="User Master"
                mode={Mode}
                onAdd={handleAdd}
                onEdit={handleEdit}
                onDelete={handleDelete}
                onExit={handleMoveBack}
                readOnlyMode={!AllButtonDisabled}
                onPrevious={handlePrevClick}
                onNext={handleNextClick}
              />
            </Grid>
          </Grid>
          {/* Stepper Section */}
          <Grid item xs={12}>
            <Stepper
              activeStep={activeStep}
              connector={<CustomStepConnector />}
              alternativeLabel
            >
              {steps.map((label, index) => (
                <Step
                  key={label}
                  onClick={() => handleStepClick(index)}
                  style={{ cursor: Mode === "view" ? "pointer" : "default" }}
                >
                  <CustomStepLabel
                    StepIconComponent={(props) => (
                      <CustomStepIcon
                        ownerState={{ ...props, active: activeStep === index }}
                      >
                        {index + 1}
                      </CustomStepIcon>
                    )}
                  >
                    {label}
                  </CustomStepLabel>
                </Step>
              ))}
            </Stepper>
          </Grid>

          {/* Content Based on Active Step */}
          <Grid item xs={12}>
            {activeStep === 0 ? (
              <UserStep1
                UserData={UserData}
                Mode={Mode}
                Index={Index}
                UserTypeNameData={UserTypeNameData}
                AllTextDisabled={AllTextDisabled}
                AllButtonDisabled={AllButtonDisabled}
                viewMode={viewMode}
                UserId={UserId}
                setMode={setMode}
                fetchUserData={fetchUserData}
                setAllTextDisabled={setAllTextDisabled}
                setAllButtonDisabled={setAllButtonDisabled}
                handleStepClick={handleStepClick}
                UserLoginId={UserLoginId}
              />
            ) : (
              <UserStep2
                UserId={UserId}
                fetchUserData={fetchUserData}
                handleStepClick={handleStepClick}
                AllTextDisabled={AllTextDisabled}
                setAllTextDisabled={setAllTextDisabled}
                setAllButtonDisabled={setAllButtonDisabled}
                UserLoginId={UserLoginId}
              />
            )}
          </Grid>
        </Grid>
      </Box>
    </Grid>
  );
};

export default UserMst;
